import fileTypeIs from '../fileTypeIs';
export default {
    mixins: [fileTypeIs],
    methods: {
        getSRCThumbnail(file, addToken = false){
            let extension_file = file.file_name && file.file_name.split(".").pop()?file.file_name.split(".").pop():null;
            if(extension_file != null){
                if(extension_file == 'pdf'){
                    return require("ks_app/src/assets/images/pdf.jpeg");
                }else if(this.fileTypeIs('audio', extension_file)){ 
                    return require("ks_app/src/assets/images/audio.png");
                }else if(this.fileTypeIs('video', extension_file)){ 
                    return require("ks_app/src/assets/images/video.jpg");
                }else{
                    let qs = addToken?`?token=${window.app.auth.urlToken}`:'';
                    return `${app.apiURL}/file/files/${file.file_code_id||file.code_id}${qs}`;
                }
            }
        }
    }
};